import BrainSvg from '../../assets/svg/boosters/brain.svg';
import RecoverSvg from '../../assets/svg/boosters/revive.svg';
import RobotSvg from '../../assets/svg/boosters/robot.svg';
import RocketSvg from '../../assets/svg/utils/rocket/rocket-highlighted.svg';
import UfoSvg from '../../assets/svg/boosters/ufo.svg';

const getBoosterIcon = (type: string) => {
  switch (type) {
    case 'brain-bot':
      return BrainSvg;
    case 'recover':
      return RecoverSvg;
    case 'ufo':
      return UfoSvg;
    case 'crash-guard':
      return RobotSvg;
    default:
      return RocketSvg;
  }
};

export default getBoosterIcon;
